
import RadioProps from './mixins/RadioProps';
import RadioButton from './radio-button';
import { RadioPropertyType, RadioEventType, RadioOptionProperty } from './enums';
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';
import { StyleOrientationType } from '@/ui-kit/styles/enums';

export default {
  name: 'RadioGroup',
  components: {
    RadioButton,
  },
  mixins: [
    RadioProps,
  ],
  data() {
    return {
      RadioPropertyType,
      RadioOptionProperty,
    };
  },
  computed: {
    radioGroupClassNames() {
      return new StyleClassNamesBuilder('radio-group')
        .addClassName(this.className)
        .addConditionClassNames(Object.values(StyleOrientationType), this.orientation)
        .build();
    },
    isDisabled() {
      return this[RadioPropertyType.Disabled];
    },
  },
  methods: {
    handleChange(value) {
      this.$emit(RadioEventType.Change, value);
    },
    getIsChecked(value) {
      return value === this[RadioPropertyType.Value];
    },
  },
};
